import Header from "../../components/Header/NewHeader";
import SideMenu from "../../components/SideMenu/SideMenu";
import HomeAffiliateComponent from "../../pages/Home/HomeAffiliate";

function HomeAffiliate() {
  return (
    <div className="view">
      <SideMenu />

      <section>
        <Header affiliate />
        <div className="content contentAffiliate">
          <HomeAffiliateComponent />
        </div>
      </section>
    </div>
  );
}

export default HomeAffiliate;
